import React from 'react';
import {Button} from "@mui/material";
import classes from "./ButtonCreateReceipt.module.scss";
import {DocumentScannerRounded} from "@mui/icons-material";

interface ButtonCreateProps {
  handleOpen: () => void;
}

const ButtonCreateReceipt = ({handleOpen}: ButtonCreateProps) => {
  return (
    <Button variant="contained" className={classes['default-button-create']} type={"button"} color={"primary"}
                   aria-label="Scan or add a receipt" onClick={handleOpen}>
      <DocumentScannerRounded className={classes['default-button-create--icon']}/>
    </Button>
  );
};

export default ButtonCreateReceipt;
